import cloneDeep from 'lodash/cloneDeep';
import keyBy from 'lodash/keyBy';

import EntityName from '../../enums/EntityName';
import EntityType from '../../types/Entity';
import Actions from '../Actions';
import { StateStatus } from '../../enums/StateStatus';
import { getActionTypeByName } from '../helpers';
import { defaultEntityState, EntityState } from './types';

export const generateEntityReducer = <T extends EntityType>(entityName: EntityName) => {
  return (state: EntityState<T> = defaultEntityState, action: Actions): EntityState<T> => {
    const { payload } = action as any;

    switch (action.type) {
      case getActionTypeByName(`CREATE_${entityName}`):
      case getActionTypeByName(`GET_${entityName}`):
      case getActionTypeByName(`GET_${entityName}_LIST`):
        return {
          ...state,
          status: StateStatus.Busy,
          error: null
        };

      case getActionTypeByName(`GET_${entityName}_LIST_SUCCESS`): {
        const list = cloneDeep(payload) as T[];
        const byId = {
          ...keyBy(list, (e) => e.id)
        };

        return {
          ...state,
          status: StateStatus.Loaded,
          error: null,
          byId
        };
      }

      case getActionTypeByName(`CREATE_${entityName}_SUCCESS`):
      case getActionTypeByName(`GET_${entityName}_SUCCESS`): {
        const entity = payload as T;
        return {
          ...state,
          status: StateStatus.Loaded,
          error: null,
          byId: {
            ...state.byId,
            [entity.id]: entity
          }
        };
      }

      case getActionTypeByName(`CREATE_${entityName}_ERROR`):
      case getActionTypeByName(`GET_${entityName}_LIST_ERROR`): {
        return { ...state, status: StateStatus.Error, error: payload };
      }

      default:
        return state;
    }
  };
};
